import React from "react";
import "./carservice.css";

export default function Carservice() {
  return (
    <section className="carservice" aria-labelledby="carservice-title">
      <div className="carservice-container">
        <div className="carservice-content">
          <div className="carservice-eyebrow">
            <span className="eyebrow-line" aria-hidden="true" />
            <span className="eyebrow-text">MOBILE AUTOMOTIVE CARE</span>
          </div>

          <h1 id="carservice-title" className="carservice-title">
            Professional Mobile
            <br />
            Auto Repair Service
          </h1>

          <p className="carservice-description">
            Expert automotive care that comes to you. Our certified technicians provide 
            comprehensive repair and maintenance services at your home, office, or location 
            of choice. From diagnostics to complex repairs, we bring the workshop to you.
          </p>

          <div className="carservice-features">
            <div className="feature-item">
              <div className="feature-icon">
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M12 2a7 7 0 00-7 7c0 4.08 3.4 7.69 6.05 10.09.53.5.92.86.95.88a1 1 0 001.36 0c.03-.02.42-.38.95-.88C15.6 16.69 19 13.08 19 9a7 7 0 00-7-7zm0 4a3 3 0 11.001 6.001A3 3 0 0112 6z" />
                </svg>
              </div>
              <span>On-Site Service</span>
            </div>
            <div className="feature-item">
              <div className="feature-icon">
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                </svg>
              </div>
              <span>Certified Technicians</span>
            </div>
            <div className="feature-item">
              <div className="feature-icon">
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <span>Quality Guaranteed</span>
            </div>
          </div>

      {/*  <a
            href={telHref}
            className="carservice-cta"
            aria-label={`Call Dempsey Mobile Service at ${phoneNumber}`}
          >
            <span className="cta-text">SCHEDULE SERVICE</span>
            <span className="cta-arrow">→</span>
          </a> */}  
        </div>
      </div>
    </section>
  );
}
